import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16 2.805a1.12 1.12 0 0 1-.914 1.08c-.796.158-1.367.833-1.367 1.615s.571 1.457 1.367 1.616c.53.107.912.557.914 1.079V9.9c0 .607-.512 1.1-1.143 1.1H1.143C.512 11 0 10.508 0 9.9V8.195a1.12 1.12 0 0 1 .914-1.08C1.71 6.958 2.28 6.283 2.28 5.5S1.71 4.043.914 3.884A1.12 1.12 0 0 1 0 2.805V1.1C0 .492.512 0 1.143 0h13.714C15.488 0 16 .492 16 1.1zM3.431 5.5c0 1.308-.957 2.435-2.288 2.695V9.9h4V1.1h-4v1.705c1.331.26 2.288 1.387 2.288 2.695",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }